import type { ButtonStyleTypes } from '@material-tailwind/react';

const styles: ButtonStyleTypes = {
  defaultProps: {
    variant: 'filled',
    size: 'md',
    color: 'blue',
    ripple: false,
  },
  valid: {
    variants: ['filled'],
    sizes: ['md'],
    colors: ['blue'],
  },
  styles: {
    base: {
      initial: {
        verticalAlign: 'align-middle',
        userSelect: 'select-none cursor-pointer',
        fontFamily: '',
        fontWeight: 'font-normal',
        textAlign: 'text-center',
        textTransform: '',
        transition: 'transition-all',
        hover: 'hover:brightness-90',
        disabled:
          'disabled:opacity-60 disabled:shadow-none disabled:drop-shadow-none disabled:pointer-events-none disabled:cursor-not-allowed',
      },
    },
    sizes: {
      md: {
        fontSize: 'text-sm leading-6',
        py: 'py-3',
        px: 'px-4',
        borderRadius: 'rounded-xl',
      },
    },
    variants: {
      filled: {
        blue: {
          hover: '',
          shadow: 'shadow-none',
        },
      },
    },
  },
};

export default styles;
